import { defineComponent as _defineComponent } from 'vue'
import { getOrderLogistics } from '@/api/order/order-list';
import TagRadio from '@/component/TagRadio.vue';
import { onBeforeMount, ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderLogistics',
  props: {
    order_id: null,
    express: null
  },
  setup(__props: any) {

const props = __props as {
  order_id: number;
  express: {
    id: number;
    company?: string;
    number?: string;
  }[];
};


const loading = ref(false);
const logistics = ref();
const expressId = ref(props?.express?.[0].id);
onBeforeMount(() => {
  watch(
    expressId,
    () => {
      getLogistics();
    },
    { immediate: true }
  );
});

async function getLogistics() {
  loading.value = true;
  const res = await getOrderLogistics(props.order_id, expressId.value);
  logistics.value = res;
  loading.value = false;
}

return { __sfc: true,props, loading, logistics, expressId, getLogistics, TagRadio }
}

})